import type { ButtonHTMLAttributes } from 'react';
import { cn } from '../cn';

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  label: string;
  size?: 'sm' | 'md' | 'mobile';
  /** Framed (border) or bare glyph (× remove buttons). */
  framed?: boolean;
  danger?: boolean;
}

/** Square glyph button: − / + steppers (24 / 32 px), × removers (bare, fg4 -> accent or bad on hover). */
export function IconButton({ label, size = 'sm', framed = true, danger, className, children, ...rest }: IconButtonProps) {
  return (
    <button
      type="button"
      aria-label={label}
      title={label}
      className={cn(
        'inline-flex items-center justify-center font-mono font-medium leading-none',
        framed && 'border border-border bg-transparent text-fg3 hover:text-fg',
        framed && size === 'sm' && 'h-6 w-6 rounded text-base',
        framed && size === 'md' && 'h-7 w-7 rounded text-md',
        framed && size === 'mobile' && 'h-8 w-8 rounded-lg text-lg',
        !framed && 'border-0 bg-transparent px-1 font-sans text-fg4',
        !framed && (danger ? 'hover:text-bad' : 'hover:text-accent'),
        !framed && size === 'sm' && 'text-md',
        !framed && size === 'md' && 'text-lg',
        !framed && size === 'mobile' && 'text-[18px]',
        className,
      )}
      {...rest}
    >
      {children}
    </button>
  );
}
